import { useState } from 'react';
import Validator from 'validatorjs';
import React, { useEffect } from 'react';
import { Button, Col, Form, Row } from 'react-bootstrap';

import { FormControl } from '../../../../facturotopia';

import ComplementoEnajenaciondeAccionesRules from '../../support/rules/complementos/ComplementoEnajenaciondeAccionesRules';

const rules = ComplementoEnajenaciondeAccionesRules;

const ComplementoEnajenaciondeAcciones = (props) => {
  const [data, setData] = useState(props.data || {});

  const [validation, setValidation] = useState({
    validator: new Validator({}, rules),
    isValid: false,
  });

  const { isValid } = validation;

  const handleOnChange = (event) => {
    const newData = {
      ...data,
      ...event,
    };

    setData(newData);
  };

  const validate = (data) => {
    const validator = new Validator(data, rules);

    const newValidator = {
      validator: validator,
      isValid: validator.passes(),
    };

    setValidation(newValidator);
  };

  useEffect(() => validate(data), [data]);

  const handleOnAdd = () => {
    const EnajenaciondeAcciones = {
      Version: '1.0',
      ContratoIntermediacion: data.ContratoIntermediacion,
      Ganancia: data.Ganancia,
      Perdida: data.Perdida,
    };

    props.onChange({ EnajenaciondeAcciones });

    clear();
  };

  const clear = () => {
    setData({});
  };

  const handleOnCancel = () => {
    props.onChange({ EnajenaciondeAcciones: undefined });
  };

  return (
    <div className="pb-4">
      <div>
          <strong className="text-black text-upper">Enajenacion de acciones</strong>
      </div>
      <div className="section">
        <Form autoComplete="off">
          <Row>
            <Col sm md={4}>
              <FormControl
                type="number"
                label="Ganancia"
                name="Ganancia"
                placeholder=""
                help=""
                autoFocus={ true }
                rules={rules.Ganancia}
                value={data.Ganancia}
                onChange={handleOnChange}
              />
            </Col>

            <Col sm md={4}>
              <FormControl
                type="number"
                label="Perdida"
                name="Perdida"
                placeholder=""
                help=""
                rules={rules.Perdida}
                value={data.Perdida}
                onChange={handleOnChange}
              />
            </Col>
          </Row>

          <Row>
            <Col sm md={12}>
              <FormControl
                as="textarea"
                label="Contrato de intermediación"
                name="ContratoIntermediacion"
                placeholder=""
                help=""
                rows="4"
                minLength="1"
                maxLength="301"
                rules={rules.ContratoIntermediacion}
                value={data.ContratoIntermediacion}
                onChange={handleOnChange}
              />
            </Col>
          </Row>

          <Row>
            <Col>
              <Button
                variant="secondary"
                className="mr-2"
                onClick={ handleOnCancel }
              >
                Cancelar
              </Button>

              <Button
                variant="primary"
                disabled={ !isValid }
                onClick={ handleOnAdd }
              >
                Agregar complemento
              </Button>
            </Col>
          </Row>
        </Form>
      </div>
    </div>
  );
};

export default ComplementoEnajenaciondeAcciones;
